import React, {ComponentPropsWithoutRef, FC} from 'react';

import {twx} from '@/utils/tailwindUtils';

import {Body} from './Body';
import {Chip} from './Chip';
import {Footer} from './Footer';
import {Header} from './Header';
import {Hero} from './Hero';
import {Progress} from './Progress';
import {Description, Title} from './Title';

type LoyaltyPopupTemplateType = FC<ComponentPropsWithoutRef<'div'>> & {
    Header: typeof Header;
    Hero: typeof Hero;
    Footer: typeof Footer;
    Progress: typeof Progress;
    Title: typeof Title;
    Description: typeof Description;
    Body: typeof Body;
    Chip: typeof Chip;
};

const LoyaltyPopupTemplate: LoyaltyPopupTemplateType = ({children, className}) => {
    return <div className={twx('flex flex-col items-center blur-0', className)}>{children}</div>;
};

LoyaltyPopupTemplate.Chip = Chip;
LoyaltyPopupTemplate.Body = Body;
LoyaltyPopupTemplate.Header = Header;
LoyaltyPopupTemplate.Hero = Hero;
LoyaltyPopupTemplate.Footer = Footer;
LoyaltyPopupTemplate.Progress = Progress;
LoyaltyPopupTemplate.Title = Title;
LoyaltyPopupTemplate.Description = Description;

Object.freeze(LoyaltyPopupTemplate);

export {LoyaltyPopupTemplate};
